module.exports = __webpack_public_path__ + "static/media/0005.2a62b3e5.jpg";